import React from 'react';

export default function PromptMailSent({ show, setViewMode }) {

    if (show) {

        return (
            <div className="modal fade show" id="errorModal" aria-modal="true" role="dialog" style={{ display: "block" }} >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <h2>Mail sent</h2>
                            <p>The appointment request was sent successfully</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={() => setViewMode('')}> Ok </button>
                        </div>
                    </div>
                </div>
            </div>
        );

    } else { return null; }

}